import React, { Component } from 'react'
import { Button, Select } from 'advenio-components'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types' //eslint-disable-line
import R from 'ramda'
import { Form } from 'formsy-react'
import ProfilePicture from '../ChildrenList/ProfilePicture'
import {
  ChildrenDiv,
  ProfileDiv,
  Container,
  Continue,
  Div,
  IconsDiv,
  ActionButton,
  Img,
  ProfileDivOverlay,
  InfoDiv,
  InfoDivOverlay,
  NameDiv,
  ChildrenInfoContainer,
} from './SelectKids.styles'

export const ChildrenContainer = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: ${props => props.group ? 'calc(80% - 75px)' : 'calc(100% - 120px)'};
  @media (max-width: 763px) {
    height: ${props => props.group ? '300px' : 'calc(80% - 40px)'};
  }
`
export const SelectAllContainer = styled.div`
 width: 100%;
 height: 40px;
 display: flex;
 justify-content: center;
 align-items: center;
 flex-direction: row;
 @media (max-width: 763px) {
   margin-top: 0;
 }

`

const SelectContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 20px;
`

let initialState = ''
let classrooms = []
let NormalRooms = []
let SickRooms = []

class KidsToSleep extends Component {
  constructor(props) {
    super(props)
    if (this.props.user.role === 'Nurse') {
      initialState = R.clone(this.props.children.filter(student => student.checkin.id !== null && student.checkin.is_virtual_center !== true))
    } else {
      initialState = R.clone(this.props.children.filter(student => student.checkin.id !== null && student.checkin.status === 'Advenio' && student.checkin.is_virtual_center !== true))
    }
    for (let i = 0; i < initialState.length; i++) {
      initialState[i].selected = false
    }
    if (this.props.group) {
      NormalRooms = R.clone(this.props.classrooms.filter(room => room.type === 'Normal'))
      for (let i = 0; i < NormalRooms.length; i++) {
        NormalRooms[i].label = NormalRooms[i].name
        NormalRooms[i].value = NormalRooms[i].id
        classrooms.push(NormalRooms[i])
      }
      SickRooms = R.clone(this.props.classrooms.filter(room => room.type === 'Sick Room'))
      for (let i = 0; i < SickRooms.length; i++) {
        SickRooms[i].label = SickRooms[i].name
        SickRooms[i].value = SickRooms[i].id
        classrooms.push(SickRooms[i])
      }
    }
    this.state = {
      childrenToRender: this.childrenToSelect(initialState),
      isComplete: false,
      childrenSelected: 0,
      allSelected: false,
      rooms: classrooms,
    }
  }


  onClick = (e) => {
    const id = e.target.id
    const aux = []
    let count = 0
    const newState = { ...this.state }
    for (let i = 0; i < newState.childrenToRender.length; i++) {
      if (newState.childrenToRender[i].id == id) {
        newState.childrenToRender[i].selected = !newState.childrenToRender[i].selected
      }
      if (newState.childrenToRender[i].selected) {
        aux.push(true)
        count++
      } else {
        aux.push(false)
      }
    }

    newState.isComplete = aux.indexOf(true) >= 0
    newState.childrenSelected = count
    this.setState(newState)
  }


  getLabel = () => {
    if (this.props.oldView == 'Nap') {
      return 'Iniciar Siesta'
    } else if (this.props.oldView == 'Report') {
      return 'Enviar Reporte'
    }
    return 'Enviar Foto'
  }

  childrenToSelect = (children) => {
    let newChildren = []
    if (this.props.oldView == 'Photo') {
      return children
    }
    for (let i = 0; i < children.length; i++) {
      if (children[i].latest_activities.length > 0) {
        if (children[i].latest_activities[0].finished_at !== null) {
          newChildren.push(children[i])
        }
      } else {
        newChildren.push(children[i])
      }
    }
    return newChildren
  }

  selectAll = () => {
    const newState = { ...this.state }
    const count = newState.childrenToRender.length
    for (let i = 0; i < newState.childrenToRender.length; i++) {
      newState.childrenToRender[i].selected = !this.state.allSelected
    }
    newState.childrenSelected = !this.state.allSelected ? count : 0
    newState.allSelected = !this.state.allSelected
    newState.isComplete = !this.state.allSelected
    this.setState(newState)
  }
  saveActivity = () => {
    let params = ''
    if (this.props.oldView == 'Nap') {
      params = {
        category_id: 3,
        students: this.state.childrenToAddActivity,
      }
    } else if (this.props.oldView == 'Report') {
      params = {
        category_id: this.props.info.category_id,
        description: this.props.info.description,
        students: this.state.childrenToAddActivity,
      }
    } else if (this.props.oldView == 'Photo') {
      params = {
        category_id: this.props.info.category_id,
        photo: this.props.info.photo,
        students: this.state.childrenToAddActivity,
      }
    }
    this.props.postGroupActivity(params)
  }

  send = () => {
    const infoToSend = []
    for (let i = 0; i < this.state.childrenToRender.length; i++) {
      if (this.state.childrenToRender[i].selected) {
        infoToSend.push({ id: this.state.childrenToRender[i].id, checkin_id: this.state.childrenToRender[i].checkin.id  })
      }
    }
    const nextState = { ...this.props.info }
    nextState['childrenToAddActivity'] = infoToSend
    this.setState(nextState, () => this.saveActivity())
  }

  selectRoom = (model) => {
    let kidsToRender = []
    const [roomSelected] = this.props.classrooms.filter(room => room.id == model.classroom)
    const roomToRender = R.clone(roomSelected)
    for (let i = 0; i < roomToRender.students.length; i++) {
      roomToRender.students[i].selected = false
      roomToRender.students[i].consumable_ids = []
      roomToRender.students[i].extras = []
    }
    if (this.props.user.role === 'Teacher') {
      kidsToRender = roomToRender.students.filter(kid => kid.checkin.id !== null && kid.checkin.status !== "Nurse's Room")
    } else {
      kidsToRender = roomToRender.students.filter(kid => kid.checkin.id !== null)
    }
    this.setState({ childrenToRender: this.childrenToSelect(kidsToRender) })
  }




  render() {
    return (
      <Container>
        <SelectAllContainer>
          <Div>
            <span>{ this.state.childrenSelected + ' Seleccionados    '}</span>
          </Div>
          <Div>
            <span style={{ color: '#3E72D7', cursor: 'pointer' }} onClick={this.selectAll}>
              {this.state.allSelected ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
            </span>
          </Div>
        </SelectAllContainer>
        {this.props.group ?
          <Form onChange={this.selectRoom}>
            <SelectContainer>
              <Select
                name="classroom"
                label="Selecciona un salon"
                value={this.state.rooms.length > 0 ? this.state.rooms[0].value : 1}
                options={this.state.rooms}
              />
            </SelectContainer>
          </Form>
          : ''}
        <ChildrenContainer group={this.props.group}>
          {
            this.state.childrenToRender.map((currentValue, index, array) => {
              return (
                <ChildrenInfoContainer key={index} >
                  <ChildrenDiv type={currentValue.type} onClick={this.onClick}>
                    <IconsDiv>
                      <ActionButton>
                        <Img src={currentValue.selected ? '/assets/checked.svg' : '/assets/emptyCheck.svg'} alt="type" id={currentValue.id} />
                      </ActionButton>
                    </IconsDiv>
                    <ProfileDiv >
                      <ProfileDivOverlay id={currentValue.id} />
                      <ProfilePicture
                        profile_image={currentValue.profile_image}
                        type={currentValue.checkin.status}
                      />
                    </ProfileDiv>
                    <InfoDiv >
                      <InfoDivOverlay id={currentValue.id} />
                      <NameDiv>
                        <span>{currentValue.first_name + ' ' +  currentValue.last_name_paternal}</span>
                      </NameDiv>
                    </InfoDiv>
                  </ChildrenDiv>
                </ChildrenInfoContainer>
              )
            })
          }
        </ChildrenContainer>
        <Continue>
          <Button
            small
            disabled={!this.state.isComplete}
            style={this.state.isComplete ? { backgroundColor: '#75B756', color: '#FFF', flex: '1' } : { backgroundColor: '#CCCCCC', color: '#FFF', flex: '1' }}
            onClick={() => this.send()}
            loading={this.props.loading}
          >
            {this.getLabel()}
          </Button>
        </Continue>
      </Container>
    )
  }
}

KidsToSleep.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KidsToSleep))



// WEBPACK FOOTER //
// ./src/Components/Activity/KidsToSleep.jsx